import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Tengo que pasar hambre?',
    a: 'No. El plan incluye grasas buenas y proteínas que te mantienen llena por horas.'
  }, {
    q: '¿Es difícil encontrar los ingredientes?',
    a: 'Para nada. Todo lo encuentras en el pasillo de especias de cualquier supermercado convencional.'
  }, {
    q: '¿Cuánto tiempo tardaré en ver resultados?',
    a: 'La mayoría de las mujeres reportan menos inflamación y más energía en las primeras 48 a 72 horas.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-16 md:py-24 bg-cream-dark" data-id="element-14">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-15">
        <FadeIn data-id="element-16">
          <div className="text-center mb-12" data-id="element-17">
            <h2 className="text-3xl md:text-4xl font-bold text-dark-brown mb-4" data-id="element-18">
              PREGUNTAS FRECUENTES
            </h2>
            <div className="w-24 h-1 bg-terracotta mx-auto rounded-full" data-id="element-19"></div>
          </div>
        </FadeIn>

        <div className="space-y-4" data-id="element-20">
          {faqs.map((faq, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-21">
              <div className="bg-white rounded-2xl shadow-sm border border-cinnamon/10 overflow-hidden" data-id="element-22">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-23">
                  <span className="text-lg font-bold text-dark-brown" data-id="element-24">
                    {faq.q}
                  </span>
                  <ChevronDown className={`w-6 h-6 text-terracotta transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-25" />
                </button>
                <AnimatePresence data-id="element-26">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-27">
                      <div className="px-6 pb-5 text-lg text-dark-brown/70 border-t border-cream-dark pt-4" data-id="element-28">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}